import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Form, Modal } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import ReactTable from 'react-table';
import OAuth, { OAuthClientStatus } from '../../../api';
import { default as Renderers } from '../../../sys/columns';
const fileDownload = require('js-file-download');
import {
    AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, Area, LineChart, Legend, Line,
} from 'recharts';
import { PureComponent } from 'react';

class State {
    showModal: boolean;
    numAliases: number;
    numVodAliases: number;
    numSchedAliases: number;
    numEventAliases: number;
    qoeActive: number;
    qoeActivePixel: number;
    qoeLicensed: number;
    groups: any;
    totTS: number;
    qoeActiveVideo: number;
    qoeActiveAudio: number;
    totMP4: number;
    totH262: number;
    totH264: number;
    totH265: number;
    data: any;
    mediaData: any;
    CPUData: any;
    portSentData: any;
    portReceivedData: any;
    portIds: any;
    maxBWValue: number;
    maxCPUValue: number;
    maxSendValue: number;
    maxReceiveValue: number;
}

interface Props {
    refresh?: number;
}

class CustomizedAxisTick extends PureComponent {
    render() {
        // @ts-ignore
        const { x, y, stroke, payload } = this.props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={6} textAnchor="end" fill="#666" transform="rotate(-35)">{payload.value.substring(0, 5)}</text>
            </g>
        );
    }
}

// @ts-ignore
const CustomTooltip = ({ active, payload, label, units }) => {
    if (active && payload !== null) {
        let value = Renderers.commaSeparated2(payload[0].value);
        return (
            <div className="custom-tooltip">
                <p className="label">{`${label} : ${value} ${units}`}</p>
            </div>
        );
    }

    return null;
};

// @ts-ignore
const CustomTooltipPort = ({ active, payload, label, units }) => {
    if (active && payload !== null) {
        let value = Renderers.commaSeparated2(payload[0].value);

        let portLabel = payload[0].payload.label;
        return (
            <div className="custom-tooltip">
                <p className="label">{`${portLabel} : ${label} : ${value} ${units}`}</p>
            </div>
        );
    }

    return null;
};

const COLORS = ['blue', 'green', 'indigo', 'teal', 'red', 'violet', 'darkblue', 'purple', 'black', 'darkgreen', 'gray', 'brown'];

export default class SystemUtilization extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        refresh: 60000
    };
    private updateTimer: number;
    private numAliases: number;
    private numVodAliases: number;
    private numSchedAliases: number;
    private numEventAliases: number;
    private qoeActive: number;
    private qoeActivePixel: number;
    private qoeLicensed: number;
    private groups: [];
    private totTS: number;
    private qoeActiveVideo: number;
    private qoeActiveAudio: number;
    private totMP4: number;
    private totH262: number;
    private totH264: number;
    private totH265: number;
    private data: any;
    private mediaData: any;
    private CPUData: any;
    private portSentData: any;
    private portReceivedData: any;
    private portIds: any;

    componentWillMount() {
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);

        this.setState({
            showModal: false,
            numAliases: 0,
            numVodAliases: 0,
            numSchedAliases: 0,
            numEventAliases: 0,
            qoeActive: 0,
            qoeActivePixel: 0,
            qoeLicensed: 0,
            groups: [],
            totTS: 0,
            qoeActiveVideo: 0,
            qoeActiveAudio: 0,
            totMP4: 0,
            totH262: 0,
            totH264: 0,
            totH265: 0,
            data: [],
            mediaData: [],
            CPUData: [],
            portSentData: [],
            portReceivedData: [],
            portIds: [],
            maxBWValue: 0,
            maxCPUValue: 0,
            maxSendValue: 0,
            maxReceiveValue: 0
            });
    }

    handleModalClose() {
        this.setState({
          showModal: false
        });
    }

    scheduleNextUpdate(ms ?: number) {
        if (ms === undefined)
            ms = this.props.refresh;
        this.updateTimer = setTimeout(() => this.fetchData(), ms);
    }

    renderMediaBWChart() {
        return (
            <AreaChart
                width={750}
                height={250}
                data={this.state.mediaData}
                margin={{
                    top: 10, right: 20, left: 0, bottom: 10,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" interval={19} tick={<CustomizedAxisTick />}/>
                <YAxis domain={[0, this.state.maxBWValue]}/>
                <Tooltip content={<CustomTooltip active payload label units={'kbps'}/>} />
                <Area type="monotone" dataKey="bw" stackId="1" stroke="#83a6ed" fill="#83a6ed" />
            </AreaChart>
        );
    }

    renderCPUChart() {
        return (
            <AreaChart
                width={750}
                height={250}
                data={this.state.CPUData}
                margin={{
                    top: 10, right: 20, left: 0, bottom: 10,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" interval={19} tick={<CustomizedAxisTick />}/>
                <YAxis unit={'%'} domain={[0, this.state.maxCPUValue]}/>/>
                <Tooltip content={<CustomTooltip active payload label units={'%'}/>} />
                <Area type="monotone" dataKey="cpu" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
            </AreaChart>
        );
    }

    // Sent Port Data
    renderTxChart() {
        return (
            <LineChart
                width={750}
                height={250}
                data={this.state.portSentData}
                margin={{
                    top: 10, right: 20, left: 0, bottom: 10,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" interval={19} tick={<CustomizedAxisTick />}/>
                <YAxis domain={[0, this.state.maxSendValue]}/>/>
                {/*<Tooltip content={<CustomTooltip active payload label units={'kbps'}/>} />*/}
                <Tooltip />
                <Legend />
                {
                    this.state.portIds.map((id: any, index: number) => { // bgColor[Math.floor(Math.random()*this.state.bgColor.length)];
                        return <Line type="monotone" key={`line_${index}`} dataKey={`${id}`} stroke={COLORS[index % COLORS.length]} />;
                    })
                }
            </LineChart>
        );
    }

    // Received Port Data
    renderRxChart() {
        return (
            <LineChart
                width={750}
                height={250}
                data={this.state.portReceivedData}
                margin={{
                    top: 10, right: 20, left: 0, bottom: 10,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" interval={19} tick={<CustomizedAxisTick />}/>
                <YAxis domain={[0, this.state.maxReceiveValue]}/>/>
                {/*<Tooltip content={<CustomTooltip active payload label units={'kbps'}/>} />*/}
                <Tooltip />
                <Legend />
                {
                    this.state.portIds.map((id: any, index: number) => {
                        return <Line type="monotone" key={`line_${index}`} dataKey={`${id}`} stroke={COLORS[index % COLORS.length]} />;
                    })
                }
            </LineChart>
        );
    }

    formatUptime(seconds: any) {
        let d = Math.floor(seconds / (3600 * 24));
        let h = Math.floor(seconds % (3600 * 24) / 3600);
        let m = Math.floor(seconds % 3600 / 60);
        let s = Math.floor(seconds % 60);

        let dDisplay = d > 0 ? d + (d === 1 ? ' day, ' : ' days, ') : '';
        let hDisplay = h > 0 ? h + (h === 1 ? ' hour, ' : ' hrs, ') : '';
        let mDisplay = m > 0 ? m + (m === 1 ? ' minute, ' : ' mins, ') : '';
        let sDisplay = s > 0 ? s + (s === 1 ? ' second' : ' secs') : '';

        return dDisplay + hDisplay + mDisplay + sDisplay;
    }

    formatNumber(props: any): React.ReactNode {
        let value = Renderers.commaSeparated2(props.value);

        return (
            <div className="right-aligned">{value}</div>
        );
    }

    fetchStats() {
        let _this = this;
        let url = 'http://default/api/sys/stats';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                let ms = 0; let time = []; let date = '';
                if (response.data.stats !== undefined) {
                    let utilStats = response.data.stats;
                    _this.mediaData = [];
                    _this.CPUData = [];
                    _this.portSentData = [];
                    _this.portReceivedData = [];
                    _this.portIds = [];
                    let item = {};
                    let propValue = '';
                    let maxBWValue = 0;
                    let maxCPUValue = 0;
                    let maxSendValue = 0;
                    let maxReceiveValue = 0;

                    for (let i = utilStats.length - 1; i >= 0; i--) {
                        ms = utilStats[i].timestamp * 1000;
                        date = new Date(ms).toString(); // Wed Apr 01 2020 11:35:00 GMT-0300 (Atlantic Daylight Time)
                        time = date.split(' ');
                        if (utilStats[i].mediaActualBW > maxBWValue) maxBWValue = utilStats[i].mediaActualBW;
                        _this.mediaData.push({time: time[4].substr(0, 8), bw: utilStats[i].mediaActualBW});
                        if (utilStats[i].cpuUtil.toFixed(2) > maxCPUValue) maxCPUValue = utilStats[i].cpuUtil.toFixed(2);
                        _this.CPUData.push({time: time[4].substr(0, 8), cpu: parseFloat(utilStats[i].cpuUtil.toFixed(2))});
                        // loop through port data
                        item = {
                            time: time[4].substr(0, 8)
                        };
                        for (let j = 0; j < utilStats[i].portStats.length; j++) {
                            if (utilStats[i].portStats[j].osName === 'lo') {
                                continue;
                            }
                            propValue = utilStats[i].portStats[j].portAlias === '' ? utilStats[i].portStats[j].osName : utilStats[i].portStats[j].portAlias;
                            if (utilStats[i].portStats[j].txRateKbps > maxSendValue) maxSendValue = utilStats[i].portStats[j].txRateKbps;
                            item[propValue] = utilStats[i].portStats[j].txRateKbps;
                        }
                        _this.portSentData.push(item);

                        item = {
                            time: time[4].substr(0, 8)
                        };
                        for (let k = 0; k < utilStats[i].portStats.length; k++) {
                            if (utilStats[i].portStats[k].osName === 'lo')
                                continue;
                            propValue = utilStats[i].portStats[k].portAlias === '' ? utilStats[i].portStats[k].osName : utilStats[i].portStats[k].portAlias;
                            if (utilStats[i].portStats[k].rxRateKbps > maxReceiveValue) maxReceiveValue = utilStats[i].portStats[k].rxRateKbps;
                            item[propValue] = utilStats[i].portStats[k].rxRateKbps;
                        }
                        _this.portReceivedData.push(item);

                        if (_this.portIds.length === 0) {
                            for (let l = 0; l < utilStats[i].portStats.length; l++) {
                                if (utilStats[i].portStats[l].osName === 'lo')
                                    continue;
                                else
                                    _this.portIds.push(utilStats[i].portStats[l].portAlias === '' ? utilStats[i].portStats[l].osName : utilStats[i].portStats[l].portAlias);
                            }
                        }
                    }

                    _this.setState({
                        mediaData: _this.mediaData,
                        CPUData: _this.CPUData,
                        portSentData: _this.portSentData,
                        portReceivedData: _this.portReceivedData,
                        portIds: _this.portIds,
                        maxBWValue, maxCPUValue, maxSendValue, maxReceiveValue
                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('expected array of values, got ', response.data);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchStats() error: ', error);
            });
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/sys/media';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    let mediaStats = response.data;

                    _this.numAliases = mediaStats.numAliases;
                    _this.numVodAliases = mediaStats.numVodAliases;
                    _this.numSchedAliases = mediaStats.numSchedAliases;
                    _this.numEventAliases = mediaStats.numEventAliases;
                    _this.qoeActive = mediaStats.qoeActive;
                    _this.qoeActivePixel = mediaStats.qoeActivePixel;
                    _this.qoeLicensed = mediaStats.qoeLicensed;
                    _this.groups = mediaStats.groups;
                    _this.qoeActiveVideo = mediaStats.qoeActiveVideo;
                    _this.qoeActiveAudio = mediaStats.qoeActiveAudio;
                    _this.totTS = mediaStats.hls.numMp2Ts + mediaStats.hss.numMp2Ts + mediaStats.hds.numMp2Ts + mediaStats.dash.numMp2Ts;
                    _this.totMP4 = mediaStats.hls.numFmp4 + mediaStats.hss.numFmp4 + mediaStats.hds.numFmp4 + mediaStats.dash.numFmp4;
                    _this.totH262 = mediaStats.hls.numMp2 + mediaStats.hss.numMp2 + mediaStats.hds.numMp2 + mediaStats.dash.numMp2;
                    _this.totH264 = mediaStats.hls.numH264 + mediaStats.hss.numH264 + mediaStats.hds.numH264 + mediaStats.dash.numH264;
                    _this.totH265 = mediaStats.hls.numH265 + mediaStats.hss.numH265 + mediaStats.hds.numH265 + mediaStats.dash.numH265;
                    _this.data = [
                        {
                            mediaType: 'Apple - HTTP Live Streaming',
                            totStreams: mediaStats.hls.numMaster,
                            variantSessions: mediaStats.hls.numVariant,
                            configuredBW: mediaStats.hls.totConfigBW,
                            actualBW: mediaStats.hls.totActualBW,
                            totFiles: mediaStats.hls.totFiles,
                            totBytes: mediaStats.hls.totBytes
                        }, {
                            mediaType: 'Microsoft - Smooth Streaming',
                            totStreams: mediaStats.hss.numMaster,
                            variantSessions: mediaStats.hss.numVariant,
                            configuredBW: mediaStats.hss.totConfigBW,
                            actualBW: mediaStats.hss.totActualBW,
                            totFiles: mediaStats.hss.totFiles,
                            totBytes: mediaStats.hss.totBytes
                        }, {
                            mediaType: 'Adobe - HTTP Dynamic Streaming',
                            totStreams: mediaStats.hds.numMaster,
                            variantSessions: mediaStats.hds.numVariant,
                            configuredBW: mediaStats.hds.totConfigBW,
                            actualBW: mediaStats.hds.totActualBW,
                            totFiles: mediaStats.hds.totFiles,
                            totBytes: mediaStats.hds.totBytes
                        }, {
                            mediaType: 'MPEG - Dynamic Adaptive Streaming',
                            totStreams: mediaStats.dash.numMaster,
                            variantSessions: mediaStats.dash.numVariant,
                            configuredBW: mediaStats.dash.totConfigBW,
                            actualBW: mediaStats.dash.totActualBW,
                            totFiles: mediaStats.dash.totFiles,
                            totBytes: mediaStats.dash.totBytes
                        }, {
                            mediaType: 'Total',
                            // tslint:disable-next-line:max-line-length
                            totStreams: mediaStats.hls.numMaster + mediaStats.hss.numMaster + mediaStats.hds.numMaster + mediaStats.dash.numMaster,
                            variantSessions: mediaStats.hls.numVariant + mediaStats.hss.numVariant + mediaStats.hds.numVariant + mediaStats.dash.numVariant,
                            configuredBW: mediaStats.totConfigBW,
                            actualBW: mediaStats.totActualBW,
                            totFiles: mediaStats.totFiles,
                            totBytes: mediaStats.totBytes
                        }];

                    _this.setState({
                       numAliases: _this.numAliases,
                       numVodAliases: _this.numVodAliases,
                       numSchedAliases: _this.numSchedAliases,
                       numEventAliases: _this.numEventAliases,
                       qoeActive: _this.qoeActive,
                       qoeActivePixel: _this.qoeActivePixel,
                       qoeLicensed: _this.qoeLicensed,
                       groups: _this.groups,
                       totTS: _this.totTS,
                       qoeActiveVideo: _this.qoeActiveVideo,
                       qoeActiveAudio: _this.qoeActiveAudio,
                       totMP4: _this.totMP4,
                       totH262: _this.totH262,
                       totH264: _this.totH264,
                       totH265: _this.totH265,
                       data: _this.data
                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('expected array of values, got ', response.data);
                }
                _this.fetchStats();
                _this.scheduleNextUpdate();
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
                _this.fetchStats();
                _this.scheduleNextUpdate();
            });
    }

    handleClick(oauth: OAuthClientStatus) {
        this.exportLogs(oauth, false);
        this.setState({
        },            () => this.setState({showModal: true}));
    }

    exportLogs(oauth: OAuthClientStatus, useRespType: boolean) {
        let _this = this;
        let filename = '';
        let url = (oauth.secureHost ? 'https' : 'http') + '://default/api/log/export?';

        filename = 'IQSystemLogs-';
        filename += this.getSysName(oauth);

        if (useRespType) { // need this when downloading actual zip file
            axios.get(url, {
                responseType: 'arraybuffer'
            })
                .then(function (response: AxiosResponse) {
                    let stringObject = response.data;
                    if (response.data) {
                        fileDownload(stringObject, filename);
                    }
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('Export System Logs error: ', error);
                });
        } else {
            axios.get(url)
                .then(function (response: AxiosResponse) {
                    if (response.data.status === 'Data collection process ongoing') {
                        setTimeout(() => {
                            _this.exportLogs(oauth, true);
                        },         30000);
                    } else {
                        setTimeout(() => {
                            _this.exportLogs(oauth, true);
                        },         3000);
                    }
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('Export System Logs error: ', error);
                });
        }
    }

    getSysName(oauth: OAuthClientStatus) {
        let now = new Date();
        let url = '';
        let sysName = (oauth.sys.name ? oauth.sys.name : 'surveyor-abr');
        // sysName = encodeURIComponent(sysName);

        url += sysName + '-';
        url += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));
        url += '.tar.gz';

        return url;
    }

    render() {
        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const columns = [
            {
                Header: (h: any) => (<span>Media <br/> Type</span>),
                accessor: 'mediaType',
                minWidth: 220,
                headerStyle: {textAlign: 'center'}
            },
            {
                Header: (h: any) => (<span>Variant <br/> Sessions</span>),
                accessor: 'variantSessions',
                minWidth: 75,
                headerStyle: {textAlign: 'center'},
                Cell: (props: any) => this.formatNumber(props)
            },
            {
                Header: (h: any) => (<span>Playlist <br/> Sessions</span>),
                accessor: 'totStreams',
                headerStyle: {textAlign: 'center'},
                minWidth: 75,
                Cell: (props: any) => this.formatNumber(props)
            },
            {
                Header: (h: any) => (<span>Configured <br/> BW (kbps)</span>),
                accessor: 'configuredBW',
                headerStyle: {textAlign: 'center'},
                minWidth: 90,
                Cell: (props: any) => this.formatNumber(props)
            },
            {
                Header: (h: any) => (<span>Actual <br/> BW (kbps)</span>),
                accessor: 'actualBW',
                headerStyle: {textAlign: 'center'},
                minWidth: 90,
                Cell: (props: any) => this.formatNumber(props)
            },
            {
                Header: (h: any) => (<span>File <br/> Count</span>),
                accessor: 'totFiles',
                headerStyle: {textAlign: 'center'},
                minWidth: 90,
                Cell: (props: any) => this.formatNumber(props)
            },
            {
                Header: (h: any) => (<span>Total <br/> Bytes (kB)</span>),
                accessor: 'totBytes',
                headerStyle: {textAlign: 'center'},
                minWidth: 90,
                Cell: (props: any) => Renderers.bytesToKB(props.value)
            }
        ];
        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    const buildVersion = oauth.sys ? oauth.sys.version : '-';
                    const upTime = oauth.sys ? this.formatUptime(oauth.sys.uptime) : '-';
                    const activeStreams = oauth.sys ? oauth.sys.activeStreams : '-';
                    const activePlaylists = oauth.sys ? oauth.sys.activePlaylists : '-';
                    const licenseFlowLimit = oauth.sys ? oauth.sys.licenseFlowLimit : '-';
                    // @ts-ignore
                    const activeSessions = oauth.sys ? activeStreams + activePlaylists + this.state.qoeActive : '-';
                    // @ts-ignore
                    const totLicenses = oauth.sys ? licenseFlowLimit + this.state.qoeLicensed : '-';

                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                {/*<Label className="system-config-pageHeader">*/}
                                {/*    System Utilization*/}
                                {/*</Label>*/}
                                <Label className="left-align-label-400">
                                    Build Version: {buildVersion}
                                </Label>
                                <Label className="left-align-label-400">
                                    System Uptime: {upTime}
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Export System Logs"
                                    title="Export Logs"
                                    onClick={(event, data) => this.handleClick(oauth)}
                                />
                            </div>
                            {/*<Label className="left-align-label-400">*/}
                            {/*    Build Version: {buildVersion}*/}
                            {/*</Label>*/}
                            {/*<Label className="left-align-label-400">*/}
                            {/*    System Uptime: {upTime}*/}
                            {/*</Label>*/}
                            <div className="vertical-flex-main">
                                {/*<Segment.Group className="system-config-segment">*/}
                                {/*    /!*<Segment className="segment-header">System Utilization</Segment>*!/*/}
                                {/*    <Segment>*/}
                                <Form>
                                    <fieldset id="fieldSetX" className="field-set graph1">
                                        <legend>Media Bandwidth (kbps) - Last 1 Hour</legend>
                                        {this.renderMediaBWChart()}
                                    </fieldset>
                                    <fieldset id="fieldSetY" className="field-set graph2">
                                        <legend>CPU Utilization - Last 1 Hour</legend>
                                        {this.renderCPUChart()}
                                    </fieldset>
                                    <div className="spacerFS"/>
                                    <fieldset id="fieldSetX" className="field-set graph1">
                                        <legend>Port Send (kbps) - Last 1 Hour</legend>
                                        {this.renderTxChart()}
                                    </fieldset>
                                    <fieldset id="fieldSetY" className="field-set graph2">
                                        <legend>Port Receive (kbps) - Last 1 Hour</legend>
                                        {this.renderRxChart()}
                                    </fieldset>
                                    <div className="spacerFS"/>
                                    <fieldset id="fieldSet1" className="field-set table1">
                                        <legend>Session Details</legend>
                                        <Label className="right-align-label-width200"/>
                                        <Label className="left-align-label-150 headingStyle">
                                            Sessions/Licenses
                                        </Label>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Playlists Sessions
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {activePlaylists}/{licenseFlowLimit}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Streaming Sessions
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {activeStreams}/{licenseFlowLimit}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Enabled for QoE Analysis
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.qoeActive}/{this.state.qoeLicensed}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Enabled for QoE Pixel Analysis
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.qoeActivePixel}/{this.state.qoeLicensed}
                                            </Label>
                                        </Form.Group>
                                    </fieldset>
                                    <fieldset id="fieldSet2" className="field-set table2">
                                        <legend>Streaming Media Statistics - Current</legend>
                                            <ReactTable
                                                className=" -striped -highlight -padded"
                                                columns={columns}
                                                onFetchData={() => this.fetchData()}
                                                data={(this.state && this.state.data) ? this.state.data : []}
                                                defaultPageSize={5}
                                                showPagination={false}
                                            />
                                    </fieldset>
                                    <div className="spacerFS"/>
                                    <fieldset id="fieldSet3" className="field-set table1">
                                        <legend>QoE Analysis Details</legend>
                                        <Label className="right-align-label-width200"/>
                                        <Label className="left-align-label-150 headingStyle">
                                            Active Decodes
                                        </Label>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Transport Stream
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.totTS}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Video
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.qoeActiveVideo}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Audio
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.qoeActiveAudio}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Fragmented MP4
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.totMP4}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                H.262
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.totH262}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                H.264
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.totH264}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                H.265
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.totH265}
                                            </Label>
                                        </Form.Group>
                                    </fieldset>
                                    <fieldset id="fieldSet4" className="field-set table2">
                                        <legend>Configuration Details</legend>
                                        <Label className="right-align-label-width200"/>
                                        <Label className="left-align-label-150 headingStyle">
                                            Count
                                        </Label>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Asset Aliases
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.numAliases}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                VOD Aliases
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.numVodAliases}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Pending Event Schedules
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.numEventAliases}
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width200">
                                                Scheduled Streams
                                            </Label>
                                            <Label className="left-align-label-150">
                                                {this.state.numSchedAliases}
                                            </Label>
                                        </Form.Group>
                                    </fieldset>
                                    <div className="spacerFS"/>
                                </Form>
                                {/*    </Segment>*/}
                                {/*</Segment.Group>*/}
                            </div>
                            <Modal
                                open={this.state.showModal}
                                onClose={this.handleModalClose}
                                size="mini"
                                style={inlineStyle.modal}
                            >
                                <Modal.Header>Export System Logs</Modal.Header>
                                <Modal.Content>
                                    Zip of log files will download in 30 seconds ...
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button className="filterPanel-primary-btn" onClick={() => this.handleModalClose()}>
                                        OK
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/systemInfo/systemUtilization.tsx